module.exports = __webpack_public_path__ + "img/7.e474d652.jpg";